<template>
  <el-table class="common-el-table-styles" height="320" :data="list" border ref="tableRef">
    <el-table-column label="序号" width="70">
      <template slot-scope="{ $index }">
        <div>{{ $index + 1 }}</div>
      </template>
    </el-table-column>
    <el-table-column prop="adAccount" label="账号名称" width="140" show-overflow-tooltip></el-table-column>
    <el-table-column prop="mediaName" label="媒体" show-overflow-tooltip></el-table-column>
    <el-table-column prop="opNames" label="管理人" show-overflow-tooltip></el-table-column>
    <el-table-column width="150">
      <template slot="header" slot-scope="scope">
        <!-- 必须显式地指定slot-scope="scope"，globalPlatformType才会更新 -->
        <div>
          <span>平台类型</span>
          <el-popover placement="top" title="批量设置" width="220">
            <!-- :class="scope.a" 让eslint不报变量未使用的错 -->
            <div :class="scope.a">
              <el-select v-model="globalPlatformType" style="width: 110px">
                <el-option v-for="item in platformsList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>

              <span style="margin-left: 10px">
                <el-button type="text" @click="onPlatformTypePopoverConfirm">确定</el-button>
              </span>
            </div>

            <el-button slot="reference" type="text">批量设置</el-button>
          </el-popover>
        </div>
      </template>

      <template slot-scope="{ row }">
        <el-select v-model="row.platform" style="width: 110px">
          <el-option v-for="item in platformsList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </template>
    </el-table-column>
    <el-table-column prop="accountMoney" label="实时账面余额" width="100"> </el-table-column>
    <el-table-column prop="lastThreeDaysConsume" label="日均消耗"></el-table-column>
    <el-table-column prop="realBalance" width="140">
      <template slot="header" slot-scope="scope">
        <span>充值实际金额</span>
        <el-button :class="scope.a" @click="clearBalacenCol" type="text">全部清除</el-button>
      </template>

      <template slot-scope="{ row, $index }">
        <el-input v-model="row.realBalance" @blur="onRealBalanceChange(row, $index)" placeholder="请输入金额"></el-input>
      </template>
    </el-table-column>
    <el-table-column prop="balance" label="充值账面金额" width="140"> </el-table-column>
    <el-table-column prop="finaRebate" label="返点"></el-table-column>
    <el-table-column prop="settleTypeName" label="结算方式"></el-table-column>

    <el-table-column prop="advertiserId" label="计划主id" show-overflow-tooltip></el-table-column>

    <el-table-column label="操作" fixed="right">
      <template slot-scope="{ $index }">
        <el-button type="text" @click="removeRow($index)">移除</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { platformsList } from './data.js'
export default {
  props: {
    list: {
      type: Array
    }
  },
  inject: ['calcBalance'],
  data() {
    return {
      platformsList,
      globalPlatformType: ''
    }
  },
  methods: {
    /**
     * @description: 全部清空余额列
     */
    clearBalacenCol() {
      const newList = this.list.map((item) => ({ ...item, realBalance: '', balance: '' }))
      this.$emit('clear-input')
      this.$emit('update-list', newList)
    },
    /**
     * @description: 移除一行
     */
    removeRow(row) {
      const newList = this.list.filter((_, i) => i !== row)
      this.$emit('update-list', newList)
    },
    /**
     * @description: 批量设置平台类型列
     */
    onPlatformTypePopoverConfirm() {
      const newList = this.list.map((item) => {
        return { ...item, platform: this.globalPlatformType }
      })
      this.$emit('update-list', newList)
    },
    onRealBalanceChange(row, idx) {
      const newList = this.list.map((item, index) => {
        if (index === idx) {
          return { ...item, balance: this.calcBalance(row.realBalance, item.finaRebate) }
        }
        return item
      })

      this.$emit('update-list', newList)
    }
  }
}
</script>

<style lang="scss" scoped></style>
